<template>
<div>
  <el-button type="success" size="small" style="margin-bottom: 10px"
             @click="handleBatchCancelOrder()" v-show="isShow('202109020001')">批量取消
  </el-button>
  <el-button type="success" size="small" style="margin-left:0px;margin-bottom: 10px"
             @click="handleBatchCancelOrder()" v-show="isShow('202109010001')">批量取消
  </el-button>
  <el-button type="success" size="small" style="margin-left:0px;margin-bottom: 10px"
             @click="handleconfirmSend()" v-show="isShow('202110040002')">批量确认发货返款
  </el-button>
  <el-button type="success" size="small" style="margin-left:0px;margin-bottom: 10px"
             @click="handleFinshconfirmSend()" v-show="isShow('202109030003')">批量确认评价
  </el-button>
  <el-button type="success" size="small" style="margin-left:0px;margin-bottom: 10px"
             @click="handleCancelPrompReivew()" v-show="isShow('202111030003')">批量取消催评
  </el-button>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="orderNumbers" label="订单编号">
        <template slot-scope="scope">
          <router-link :to="{path:'/home/taskorderdetail', query:{orderId:scope.row.orderId, taskNumbers:null}}">
            <span style="color: #04befe">{{ scope.row.orderNumbers }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="taskType" label="任务类型" />
      <el-table-column prop="plateformOrderNumbers" label="平台单号" />
      <el-table-column prop="customerAccount" label="平台账号">
      </el-table-column>
      <el-table-column prop="taskId" label="任务编号" >
        <template slot-scope="scope">
          <router-link :to="{path:'/home/businesstaskdetails', query: {b2cTaskId:scope.row.taskId}}">
            <span style="color: #04befe">{{ scope.row.taskId }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="businessStoreName" label="商家" >
        <template slot-scope="scope">
          <router-link :to="{path:'/home/storedetail', query: {userId:scope.row.bussinessStoreId}}">
            <span style="color: #04befe">{{ scope.row.businessStoreName }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="试客">
        <template slot-scope="scope">
          <router-link :to="{path:'/home/customerdetail', query: {customerId:scope.row.customerId}}">
            <span style="color: #04befe">{{ scope.row.customerName }}</span>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺" />
      <el-table-column prop="orderMoneyInfo" label="订单金额" width="120"/>
      <el-table-column prop="beginTime" label="开始时间" />
      <el-table-column prop="endTime" label="结束时间" />
      <el-table-column prop="statusStr" label="订单状态" />
      <el-table-column prop="orderRemarks" label="订单备注" />
      <el-table-column prop="ownerWeb" label="所属分站" />
      <el-table-column label="操作" width="280" align="center">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="24" style="margin-top: 5px;">
              <el-button size="mini" type="success" plain v-if="scope.row.isAssignBusiness && scope.row.statusStr == '待接单'"
                         @click="handleAssignEdit(scope.$index, scope.row,'指派-'+scope.row.taskType)">
                指派
              </el-button>
              <el-button size="mini" type="success" plain v-if="scope.row.statusStr !== '已完成' && scope.row.statusStr !== '已取消' && scope.row.statusStr !== '追评'"
                         @click="handleEdit(scope.$index, scope.row,'订单结算-'+scope.row.orderNumbers)">
                结算
              </el-button>
              <el-button size="mini" type="success" plain v-if="scope.row.statusStr == '追评'"
                         @click="handleCancelRejectReview(scope.$index, scope.row)">
                取消追评
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="goToOrderDetail(scope.$index, scope.row)">
                查看
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="handleLogEdit(scope.$index, scope.row,'日志信息')">
                日志
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="handleRemarksEdit(scope.$index, scope.row,'设置备注')">
                备注
              </el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>


  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
      <el-form-item label="开始时间">
        <span>{{dialogForm.beginTime}}</span>
      </el-form-item>
      <el-form-item label="订单编号">
        <span>{{ dialogForm.orderNumbers}}</span>
      </el-form-item>
      <el-form-item label="订单商家">
        <span>{{ dialogForm.businessStoreName}}</span>
      </el-form-item>
      <el-form-item label="订单试客">
        <span>{{dialogForm.customerName}}</span>
      </el-form-item>
      <el-form-item label="返款类型">
        <span>{{ dialogForm.returnType}}</span>
      </el-form-item>
      <el-form-item label="本金返款">
        <span>{{dialogForm.moneyReturn}}</span>
      </el-form-item>
      <el-form-item label="本金返款状态">
        <span>{{ dialogForm.moneyReturnStatus ? "已返款":"未返款"}}</span>
      </el-form-item>
      <el-form-item label="佣金返款状态">
        <span>{{dialogForm.comissionReturnStatus ? "已返款":"未返款"}}</span>
      </el-form-item>
      <el-form-item label="订单金额">
        <span style="color: red;">
          <span>本金：{{dialogForm.money}}</span>
          <span style="margin-left: 1%;">运费：{{dialogForm.expressMoney}}</span>
          <span style="margin-left: 1%;">服务费：{{dialogForm.serviceMoney}}</span>
          <span style="margin-left: 1%;">手续费：{{dialogForm.serviceFee}}</span>
          <span style="margin-left: 1%;">附加服务费：{{dialogForm.moreServiceMoney}}</span>
          <span style="margin-left: 1%;">评价服务费：{{dialogForm.taskReviewServiceMoney}}</span>
          <span style="margin-left: 1%;">合计：{{canculateMoney(dialogForm)}}</span>
        </span>
      </el-form-item>
      <el-form-item label="可结算金额">
        <span style="color: red">{{dialogForm.totalMoney}}</span>
      </el-form-item>
      <el-form-item label="试客金额">
        <el-input v-model="dialogForm.customerMoney" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="商家金额">
        <el-input v-model="dialogForm.businessStoreMoney" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="结算状态">
        <el-radio-group v-model="dialogForm.orderStatus">
          <el-radio :label="202109030005">取消订单</el-radio>
          <el-radio :label="202109030004">完成订单</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="dialogForm.orderRemarks" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitCanculateDialogForm" size="mini" type="primary">结算</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogBusinessTitle" :visible.sync="dialogBusinessFormVisible">
    <el-form ref="dialogBusinessForm" :model="dialogBusinessForm" label-width="220px">
      <el-form-item label="备注">
        <el-input v-model="dialogBusinessForm.remarks" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogBusinessForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleBusinessCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogAssignTitle" :visible.sync="dialogAssignFormVisible">
    <el-form ref="dialogAssignForm" :model="dialogAssignForm" label-width="220px">
      <el-form-item label="账号">
        <el-input v-model="dialogAssignForm.userName" placeholder="请输入指派账号信息" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogAssifnForm" size="mini" type="primary">指派</el-button>
      <el-button @click="handleAssignCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <!--start日志对话框start-->
  <el-dialog v-loading="isLoading" :title="dialogLogTitle" :visible.sync="dialogLogFormVisible" @close="closeDialogLog">
    <div>
      <el-steps direction="vertical" :active="2" align-center>
        <el-step v-for="(item, index) in dialogLogData.orderOperationInfos" :status="item.isStepsAction?'finish':'wait'"  :description="getDescription(item)" :key="index">
          <template v-slot:title>
            <span>{{item.stepsTitle}}</span><span style="font-size:1rem; padding-left: 15%;">{{item.stepsTime}}</span>
          </template>
        </el-step>
      </el-steps>
    </div>
    <el-divider><i class="el-icon-view"></i></el-divider>
    <div>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header">
              <span>订单支付截图</span>
            </div>
            <el-image
                style="min-width: 10rem; min-height: 10rem"
                :src="dialogLogData.orderPayImage"
                :preview-src-list="dialogLogData.orderPayImages" lazy>
            </el-image>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>订单评价截图</span>
          </div>
            <el-image
                style="min-width: 10rem; min-height: 10rem"
                :src="dialogLogData.reviewImagesUrl"
                :preview-src-list="dialogLogData.reviewImagesUrlsAry" lazy>
            </el-image>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleLogCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
  <!--end日志对话框end-->
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  addOrderRemarks, assignOrderToCustomer, cancelBatchPrompReview, cancelOrders, changeMoneyLogs,
  getAdminOrderVoList,
  getOrderMoneyInfo, queryOrderLogDetail, rejectExtraReviewOperInfo, updateBatchOrderStatus
} from "../api/b2cbusiness/b2c_orderlist";
import {getStrEndWithNumbers, isStrEmpty} from "../lib/utils";
import qs from "qs";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "TableData",
  mixins:[MixinCUD, MinxinScroll],
  prop: ["orderStatus"],
  data(){
    return {
      statusTmp: this.orderStatus,
      tableData:[],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      dialogBusinessFormVisible: false,
      dialogBusinessTitle: "",
      dialogBusinessRefName: "dialogBusinessForm",
      dialogBusinessForm:{

      },
      dialogAssignFormVisible: false,
      dialogAssignTitle: "",
      dialogAssignRefName: "dialogAssignForm",
      dialogAssignForm:{

      },
      dialogLogFormVisible: false,
      dialogLogTitle: "",
      isLoading: false,
      queryLogForm:{},
      dialogLogData:{},
      orderStatus: this.orderStatus,
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  computed:{
    getDescription(){
      return function (itemCon) {
        return itemCon.b2cOrderOpcontents.map(item=>{
          return (isStrEmpty(item.orderOperationKey)||item.orderOperationKey.indexOf("Checked")!=-1?"":item.orderOperationKey+":")+(isStrEmpty(item.orderOperationValue)?"":item.orderOperationValue)
        }).join(',');
      }
    },
    canculateMoney(){
      return function (moneyObj) {
        let moneyTotal =   parseFloat(moneyObj.money);

        moneyTotal = moneyTotal + parseFloat(moneyObj.serviceMoney) + parseFloat(moneyObj.expressMoney) + parseFloat(moneyObj.serviceFee) + parseFloat(moneyObj.moreServiceMoney);

        moneyTotal = moneyTotal + parseFloat(moneyObj.taskReviewServiceMoney);

        return moneyTotal;
      }
    }
  },
  created() {
    this.tableHeight = document.body.clientHeight - 320;
    //this.getData();
  },
  methods: {
    //新增取消追评
    handleCancelRejectReview(index, row){
      this.$confirm("确认取消订单：" + row.orderNumbers).then(_=>{
        rejectExtraReviewOperInfo(row).then(res=>{
          if (res.success){
            this.getData()
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    exportOrderInfos(queryform){
      window.open("https://api.weiquanai.com/b2corder/exportadminorderlist?"+qs.stringify({
        orderId: queryform.orderId,
        plateformOrderNumbers: queryform.plateformOrderNumbers,
        taskId: queryform.taskId,
        businessStoreName: queryform.businessStoreName,
        shopName:queryform.shopName,
        customerName:queryform.customerName,
        customerPlateformUserName:queryform.customerPlateformUserName,
        taskType:queryform.taskType,
        status:queryform.status,
        moneyReturnStatus: queryform.moneyReturnStatus,
        orderTime:queryform.orderTime,
        startTime: queryform.timeRange?queryform.timeRange[0]:null,
        endTime: queryform.timeRange?queryform.timeRange[1]:null,
        pageNum: -1,
        pageSize: -1
      }),"_blank");
    },
    //新增批量取消催评
    handleCancelPrompReivew(){
      cancelBatchPrompReview(this.multipleSelection).then(res =>{
        if (res.success) {
          this.$message.success("批量取消催评成功！")
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    isShow(menu) {
      if (menu == this.statusTmp) {
        return true;
      } else {
        return false;
      }
    },
    handleconfirmSend() {
      this.$confirm("确定批量发货返款?").then(_ => {
        updateBatchOrderStatus({orderIds: this.multipleSelection, stepNum: 4, orderStatus: "待评价"}).then(res => {
          if (res.success) {
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      });
    },
    handleFinshconfirmSend() {
      updateBatchOrderStatus({orderIds: this.multipleSelection, stepNum: 6, orderStatus: "已完成"}).then(res => {
        if (res.success) {
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleBatchCancelOrder() {
      this.$confirm("确定取消订单?").then(_ => {
        cancelOrders(this.multipleSelection).then(res => {
          if (res.success) {
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    handleLogEdit(index, row, dialogLogTitle){
      this.dialogLogFormVisible = true;
      this.dialogLogTitle = dialogLogTitle
      this.isLoading = true;
      queryOrderLogDetail(row).then(res=>{
        if (res.success){
          this.dialogLogData = res.data;
          this.isLoading = false;
        }
      }).catch(err => {
        this.isLoading = false;
        this.$message({message: err.message, type: 'error'});
        this.handleLogCloseDialog();
      });
    },
    closeDialogLog(){
      this.dialogLogData = {};
      this.dialogLogFormVisible = false;
    },
    handleLogCloseDialog(){
      this.dialogLogFormVisible = false;
    },
    submitDialogAssifnForm(){
      this.$refs[this.dialogAssignRefName].validate((valid) => {
        if (valid) {
          this.$confirm("该订单开始时间还没到,确认继续指派该订单吗?")
              .then(_ => {
                assignOrderToCustomer(this.dialogAssignForm).then(res=>{
                  if (res.success){
                    this.dialogAssignFormVisible = false;
                    this.$message.success("更新数据成功！")
                    this.getData();
                    this.$forceUpdate();
                  }
                });
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    submitCanculateDialogForm(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                if (parseFloat(this.dialogForm.totalMoney) < (this.dialogForm.customerMoney!=null?parseFloat(this.dialogForm.customerMoney):0.0) + (this.dialogForm.businessStoreMoney!=null?parseFloat(this.dialogForm.businessStoreMoney):0.0)){
                  this.$message.error("结算金额大于可结算金额， 请重新填写！")
                }else{
                  changeMoneyLogs(this.dialogForm).then(res=>{
                    if (res.success){
                      this.dialogFormVisible = false;
                      this.$message.success("更新数据成功！")
                      this.getData();
                      this.$forceUpdate();
                    }
                  }).catch(err => {
                    this.$message({message: err.message, type: 'error'});
                  });
                }
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleAssignEdit(index, row, title){
      this.dialogAssignFormVisible = true;
      this.dialogAssignTitle = title
      this.resetDialogAssignForm()
      this.dialogAssignForm = {...row}
    },
    changeOrderTabs(tab) {
      //console.log("changeOrderTabs----", tab)
      this.statusTmp = tab.value;
      getAdminOrderVoList({status:tab.value}, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData(queryForm){
      if (queryForm != null){
        queryForm.status = this.statusTmp;
      }else{
        queryForm = {status:this.statusTmp};
      }
      getAdminOrderVoList(queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitDialogBusinessForm(){
      this.$refs[this.dialogBusinessRefName].validate((valid) => {
        if (valid) {
          console.log(this.dialogBusinessForm);
          this.$confirm("确定提交数据么?")
              .then(_ => {
                console.log(this.dialogBusinessForm);
                addOrderRemarks(this.dialogBusinessForm).then(res=>{
                  if (res.success){
                    this.dialogBusinessFormVisible = false;
                    this.$message.success("更新数据成功！")
                    this.getData();
                    this.$forceUpdate();
                  }
                }).catch(err => {
                  this.$message({message: err.message, type: 'error'});
                })
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleBusinessCloseDialog();});
        } else {
          return false;
        }
      });
    },
    resetDialogBusinessForm(){
      for(let item in this.dialogBusinessForm){
        if (typeof this.dialogBusinessForm[item]==='string'){
          this.dialogBusinessForm[item]='';
        } else if (this.dialogBusinessForm[item] instanceof Array) {
          this.dialogBusinessForm[item]=[];
        } else{
          this.dialogBusinessForm[item]=null
        }
      }
    },
    resetDialogAssignForm(){
      for(let item in this.dialogAssignForm){
        if (typeof this.dialogAssignForm[item]==='string'){
          this.dialogAssignForm[item]='';
        } else if (this.dialogAssignForm[item] instanceof Array) {
          this.dialogAssignForm[item]=[];
        } else{
          this.dialogAssignForm[item]=null
        }
      }
    },
    handleBusinessCloseDialog(){
      this.$refs[this.dialogBusinessRefName].resetFields();
      this.dialogBusinessFormVisible = false;
    },
    handleAssignCloseDialog(){
      this.$refs[this.dialogAssignRefName].resetFields();
      this.dialogAssignFormVisible = false;
    },
    handleEdit(index, row,dialogTitle) {
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
      getOrderMoneyInfo(row).then(res=>{
        if (res.success){
          this.dialogForm = {...this.dialogForm, ...res.data}
          this.$forceUpdate();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleRemarksEdit(index, row, title){
      this.dialogBusinessFormVisible = true;
      this.dialogBusinessTitle = title
      this.resetDialogBusinessForm()
      this.dialogBusinessForm = {...row}
      console.log(this.dialogBusinessForm)
    },
    goToOrderDetail(index, row){
      this.$router.push({path:'/home/taskorderdetail', query:{orderId:row.orderId, taskNumbers:null}});
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      //this.submitQueryForm()
      this.$emit("queryData")
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      //this.submitQueryForm()
      this.$emit("queryData")
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  },
  watch:{
    orderStatus(val){
      //console.log("-----", this.orderStatus);
      this.statusTmp = val;
    }
  }
}
</script>

<style lang="scss" scoped>
.box-card {
  text-align: center;
}
/deep/.el-image__error{
  width: 10rem;
  height: 10rem;
}

.el-form-item{
  margin-bottom: 1px;
}

/deep/ .el-step__title{
  font-size: 18px;
 }

 /deep/ .el-step__description{
   font-size: 14px;
 }
</style>
